import { BaseApi } from './base.api.js';

export class RpoRecommendationApi extends BaseApi {
    constructor(client) {
        super(client, '/rpo-recommendation');
    }
}
